import React from 'react';

const Label = ({ text }) => (
  <label className="text-xs font-semibold text-gray-200">{text}</label>
);

export default Label;
